import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomTextField from '../base/CustomTextField';
import {
	getOldestValidDOB,
	getYoungestValidDOB,
} from 'pages/NewNonEmployee/_util';

/**
 * Prompt user for input: date of birth
 * @returns {ReactElement} textbox prompting for date of birth
 */
const DateOfBirth = () => {
	const minDate = getOldestValidDOB(true);
	const maxDate = getYoungestValidDOB(true);
	return (
		<CustomTextField
			name={NEW_NON_EMPLOYEE_KEYS.DATE_OF_BIRTH}
			label='Date Of Birth'
			required
			InputLabelProps={{ shrink: true }}
			type='date'
			InputProps={{
				inputProps: { min: minDate, max: maxDate },
			}}
		/>
	);
};
export default DateOfBirth;
